<section
  class="bg-ayr-black text-ayr-white flex justify-center dark:bg-ayr-black py-8"
>
  <div
    class="p-8 lg:mx-0 lg:max-w-960 lg:flex lg:items-center lg:justify-between lg:w-full lg:gap-14"
  >
    <div class="max-w-[500px]">
      <p class="lg:text-21 navigation-item-bold">
        {{ "home.ayr-is.a-sustainability" | translate }}
      </p>
      <p class="lg:text-21 mt-5">
        {{ "home.ayr-is.designed-to-connect" | translate }}
      </p>
    </div>
    <ul
      class="mt-8 text-h3 lg:grid lg:h-full lg:items-center lg:mt-0 lg:text-37 space-y-4"
    >
      <li>
        <a
          [routerLink]="'/citizens'"
          role="link"
          class="cursor-pointer duration-200 flex gap-4 items-center font-bold navigation-item-bold"
        >
          <span
            class="underline text-bold hover:no-underline"
            data-toggle="tooltip"
            title="{{ 'navbar.menu.tooltip.citizens' | translate }}"
            >{{ "navbar.menu.citizens" | translate }}</span
          >
          <img
            src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/arrow-forward-white.svg"
            height="20px"
            width="20px"
            alt=" arrow forward"
            loading="lazy"
          />
        </a>
      </li>
      <li class="">
        <a
          [routerLink]="'/cities'"
          role="link"
          class="cursor-pointer duration-200 flex gap-4 items-center font-bold navigation-item-bold"
        >
          <span
            class="underline text-bold hover:no-underline"
            data-toggle="tooltip"
            title="{{ 'navbar.menu.tooltip.cities' | translate }}"
            >{{ "navbar.menu.cities" | translate }}</span
          >
          <img
            src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/arrow-forward-white.svg"
            height="20px"
            width="20px"
            alt="arrow forward "
            loading="lazy"
          />
        </a>
      </li>
      <li class="">
        <a
          [routerLink]="'/businesses'"
          role="link"
          class="cursor-pointer duration-200 flex gap-4 items-center font-bold navigation-item-bold"
        >
          <span
            class="underline text-bold hover:no-underline"
            data-toggle="tooltip"
            title="{{ 'navbar.menu.tooltip.businesses' | translate }}"
            >{{ "navbar.menu.businesses" | translate }}</span
          >
          <img
            src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/arrow-forward-white.svg"
            height="20px"
            width="20px"
            alt="arrow forward"
            loading="lazy"
          />
        </a>
      </li>
    </ul>
  </div>
</section>
